export enum LOG_LEVEL_TYPES {
  DEBUG,
  NONE,
}

export const LOG_LEVEL: LOG_LEVEL_TYPES = LOG_LEVEL_TYPES.DEBUG;
